import React, { useEffect, useState } from 'react';

import { APIService } from '../../../services/apiService';

import FormGroup from '@mui/material/FormGroup';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import Autocomplete from '@mui/material/Autocomplete';
import { styled } from '@mui/material/styles';

import { useAuth, useSchools } from '../../../contexts';
import { MasterTrackDTO } from '../../../DTO/MasterTrackDTO';
import { useApplication, useUpdateApplication } from '..';
import { ApplicationStatus } from '../../../util/enumerations';
import { HOME_SCHOOL_ID } from '../../../constants';

const StyledTextField = styled(TextField)({
	marginTop: '16px',
	marginRight: '12px',
	display: 'block',
});

const StyledFormControl = styled(FormControl)({
	marginTop: '16px',
	marginRight: '12px',
	display: 'block',
});


const api = new APIService();

export const ApplicationHeadFields = () => {
	const schools = useSchools();
	const { user } = useAuth();
	const { application, privileges } = useApplication();
	const { setMasterProgram, setYear, handleSelectSchool } =
		useUpdateApplication();

	const [masterTracks, setMasterTracks] = useState<MasterTrackDTO[]>([]);

	const getMasterTracks = () => {
		if (masterTracks.length == 0)
			api.getMasterTracks().then((data) => setMasterTracks(data));
	};

	useEffect(() => {
		getMasterTracks();
	}, [privileges.editCourses]);

	return React.useMemo(
		() => (
			<form>
				<FormGroup row>
					{user?.isAdmin ? (
						<>
							<StyledTextField
								type="text"
								value={application.user?.name}
								label="Student"
								variant="outlined"
								disabled={true}
							/>
							<StyledTextField
								type="text"
								value={application.user?.email}
								label="Email"
								variant="outlined"
								disabled={true}
							/>
						</>
					) : null}
				</FormGroup>

				<FormGroup row>
				{ masterTracks.length > 0 && (
					<StyledFormControl variant="outlined">
						<InputLabel id="university-select-label">
							Track
						</InputLabel>
						<Select
							variant="outlined"
							label="Master Track"
							value={application.masterTrackId}
							onChange={(e) =>
								setMasterProgram(e.target.value as number)
							}
							disabled={!privileges.editCourses}
							displayEmpty
							style={{ minWidth: '200px' }}
						>
							{masterTracks.map((s) => {
								return (
									<MenuItem value={s.id} key={s.id}>
										{s.name}
									</MenuItem>
								);
							})}
						</Select>
					</StyledFormControl>
					)}
					<StyledTextField
						type="number"
						value={application.year || ''}
						disabled={!privileges.editCourses}
						label="Year of departure"
						variant="outlined"
						onChange={(e) => setYear(Number(e.target.value))}
					/>
					{schools && schools.length > 0 &&

					(<Autocomplete
						getOptionLabel={(s) => `${s.name} - ${s.country?.name || ''}`}
						value={application.school}
						style={{ minWidth: '210px' }}
						onChange={(e, school) =>
							school && handleSelectSchool(school)
						}
						isOptionEqualToValue={(option, value) =>
							option.id === value.id
						}
						disabled={application.status !== ApplicationStatus.New}
						options={
							schools?.filter((s) => s.id != HOME_SCHOOL_ID) || []
						}
						renderInput={(params) => (
							<TextField
								{...params}
								label="University"
								margin="normal"
								variant="outlined"
								helperText={
									application.school
										? ''
										: 'If you cannot find your university, please inform admin before proceeding'
								}
							/>
						)}
					/>)}
				</FormGroup>
			</form>
		),
		[
			user?.isAdmin,
			application.user,
			application.masterTrackId,
			setMasterProgram,
			privileges.editCourses,
			masterTracks,
			application.year,
			setYear,
			application.school,
			handleSelectSchool,
			application.status,
			schools,
		]
	);
};
